export default __webpack_public_path__ + "static/media/notification.d25f5131.svg";